/**
 * @generated SignedSource<<76349e32d077740a3040099ad4ac4f4e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateUserInput = {
  aim?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  description?: string | null | undefined;
  displayName?: string | null | undefined;
  email?: string | null | undefined;
  firstName?: string | null | undefined;
  id: string;
  jabber?: string | null | undefined;
  jobRole?: string | null | undefined;
  lastName?: string | null | undefined;
  locale?: string | null | undefined;
  nicename?: string | null | undefined;
  nickname?: string | null | undefined;
  password?: string | null | undefined;
  profileArticleLinks?: ReadonlyArray<User_meta_ProfileArticleLinks_RepeaterInput | null | undefined> | null | undefined;
  profileImage?: string | null | undefined;
  profileSocialLinks?: ReadonlyArray<User_meta_ProfileSocialLinks_RepeaterInput | null | undefined> | null | undefined;
  registered?: string | null | undefined;
  richEditing?: string | null | undefined;
  roles?: ReadonlyArray<string | null | undefined> | null | undefined;
  websiteUrl?: string | null | undefined;
  yim?: string | null | undefined;
};
export type User_meta_ProfileArticleLinks_RepeaterInput = {
  iconName?: string | null | undefined;
  name?: string | null | undefined;
  url?: string | null | undefined;
};
export type User_meta_ProfileSocialLinks_RepeaterInput = {
  name?: string | null | undefined;
  url?: string | null | undefined;
};
export type User_UpdateUser_Mutation$variables = {
  input: UpdateUserInput;
};
export type User_UpdateUser_Mutation$data = {
  readonly updateUser: {
    readonly user: {
      readonly avatar: {
        readonly url: string | null | undefined;
      } | null | undefined;
      readonly email: string | null | undefined;
      readonly firstName: string | null | undefined;
      readonly forms: {
        readonly nodes: ReadonlyArray<{
          readonly id: string;
        }>;
      } | null | undefined;
      readonly id: string;
      readonly lastName: string | null | undefined;
      readonly meta: {
        readonly jobRole: string | null | undefined;
        readonly profileArticleLinks: ReadonlyArray<{
          readonly iconName: string | null | undefined;
          readonly name: string | null | undefined;
          readonly url: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly profileImage: {
          readonly description: string | null | undefined;
          readonly id: string;
          readonly mediaDetails: {
            readonly sizes: ReadonlyArray<{
              readonly name: string | null | undefined;
              readonly sourceUrl: string | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly mediaItemUrl: string | null | undefined;
          readonly mimeType: string | null | undefined;
        } | null | undefined;
        readonly profileSocialLinks: ReadonlyArray<{
          readonly name: string | null | undefined;
          readonly url: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly name: string | null | undefined;
      readonly nicename: string | null | undefined;
      readonly registeredDate: string | null | undefined;
      readonly role: string | null | undefined;
      readonly slug: string | null | undefined;
      readonly username: string | null | undefined;
      readonly znglists: {
        readonly nodes: ReadonlyArray<{
          readonly id: string;
        }>;
      } | null | undefined;
      readonly znglyVideos: {
        readonly nodes: ReadonlyArray<{
          readonly id: string;
        }>;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type User_UpdateUser_Mutation = {
  response: User_UpdateUser_Mutation$data;
  variables: User_UpdateUser_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v4 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v5 = [
  (v4/*: any*/),
  {
    "kind": "Literal",
    "name": "where",
    "value": {
      "stati": [
        "PUBLISH",
        "HIDDEN"
      ]
    }
  }
],
v6 = [
  (v1/*: any*/)
],
v7 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateUserPayload",
    "kind": "LinkedField",
    "name": "updateUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "username",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "role",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nicename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "registeredDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "size",
                "value": 10
              }
            ],
            "concreteType": "Avatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": "avatar(size:10)"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User_Meta",
            "kind": "LinkedField",
            "name": "meta",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jobRole",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MediaItem",
                "kind": "LinkedField",
                "name": "profileImage",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mediaItemUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mimeType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MediaDetails",
                    "kind": "LinkedField",
                    "name": "mediaDetails",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MediaSize",
                        "kind": "LinkedField",
                        "name": "sizes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sourceUrl",
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User_Meta_profileSocialLinks",
                "kind": "LinkedField",
                "name": "profileSocialLinks",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User_Meta_profileArticleLinks",
                "kind": "LinkedField",
                "name": "profileArticleLinks",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "iconName",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "UserToZnglyVideoConnection",
            "kind": "LinkedField",
            "name": "znglyVideos",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ZnglyVideo",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": (v6/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": "znglyVideos(first:1,where:{\"stati\":[\"PUBLISH\",\"HIDDEN\"]})"
          },
          {
            "alias": null,
            "args": [
              (v4/*: any*/)
            ],
            "concreteType": "UserToFormConnection",
            "kind": "LinkedField",
            "name": "forms",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Form",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": (v6/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": "forms(first:1)"
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "UserToZnglistConnection",
            "kind": "LinkedField",
            "name": "znglists",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Znglist",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": (v6/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": "znglists(first:1,where:{\"stati\":[\"PUBLISH\",\"HIDDEN\"]})"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "User_UpdateUser_Mutation",
    "selections": (v7/*: any*/),
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "User_UpdateUser_Mutation",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "beb8122ec9fe59041c4af0f74f2fe4fb",
    "id": null,
    "metadata": {},
    "name": "User_UpdateUser_Mutation",
    "operationKind": "mutation",
    "text": "mutation User_UpdateUser_Mutation(\n  $input: UpdateUserInput!\n) {\n  updateUser(input: $input) {\n    user {\n      id\n      username\n      name\n      role\n      slug\n      email\n      nicename\n      firstName\n      lastName\n      registeredDate\n      avatar(size: 10) {\n        url\n      }\n      meta {\n        jobRole\n        profileImage {\n          id\n          mediaItemUrl\n          mimeType\n          mediaDetails {\n            sizes {\n              sourceUrl\n              name\n            }\n          }\n          description\n        }\n        profileSocialLinks {\n          name\n          url\n        }\n        profileArticleLinks {\n          name\n          iconName\n          url\n        }\n      }\n      znglyVideos(first: 1, where: {stati: [PUBLISH, HIDDEN]}) {\n        nodes {\n          id\n        }\n      }\n      forms(first: 1) {\n        nodes {\n          id\n        }\n      }\n      znglists(first: 1, where: {stati: [PUBLISH, HIDDEN]}) {\n        nodes {\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "758ed45be253602cf9bc1e18dedd4d12";

export default node;
